export const getSchedulingField = details => {
  if (details?.scheduling_type === 'deadline') return 'deadline_at';
  if (details?.scheduling_type === 'schedule') return 'scheduled_at';
  if (details?.scheduled_at) return 'scheduled_at';
  if (details?.deadline_at) return 'deadline_at';
  return 'scheduled_at';
};

export const buildSchedulingDetails = ({
  sourceDetails = {},
  scheduledAt,
  isReschedule = false,
  changedAt = new Date().toISOString(),
}) => {
  const targetField = getSchedulingField(sourceDetails);
  const staleField =
    targetField === 'scheduled_at' ? 'deadline_at' : 'scheduled_at';
  const currentDate = sourceDetails[targetField] || sourceDetails[staleField];
  const historyEntry =
    isReschedule && currentDate
      ? [
          {
            from_date: currentDate,
            to_date: scheduledAt,
            changed_at: changedAt,
          },
        ]
      : [];

  return {
    ...sourceDetails,
    scheduling_type: targetField === 'deadline_at' ? 'deadline' : 'schedule',
    [targetField]: scheduledAt,
    [staleField]: null,
    rescheduled: isReschedule,
    rescheduling_history: [
      ...(sourceDetails.rescheduling_history || []),
      ...historyEntry,
    ],
  };
};
